/** Admin/supervisor operations: dashboard, planning, job detail, dispatch, map. */
export default {
  dashboard: {
    title: 'Accueil',
    openPlanning: 'Ouvrir le planning',
    todayPlanning: 'Planning aujourd’hui',
    noJobsToday: 'Aucun ménage prévu aujourd’hui.',
    issues: 'Problèmes nécessitant attention',
    noIssues: 'Rien à signaler pour le moment.',
    metrics: 'Indicateurs',
    mapPreview: 'Ménages du jour',
    openMap: 'Ouvrir la carte',
  },
  summary: {
    total: 'Ménages aujourd’hui',
    assigned: 'Assignés',
    toAssign: 'À assigner',
    inProgress: 'En cours',
    completedHint_one: '{{count}} terminé',
    completedHint_other: '{{count}} terminés',
    activeEmployees: 'Employés actifs',
    expectedRevenue: 'Revenus prévus',
    expectedPayroll: 'Paie prévue',
  },
  issues: {
    UNASSIGNED_JOBS_one: '{{count}} ménage à assigner cette semaine',
    UNASSIGNED_JOBS_other: '{{count}} ménages à assigner cette semaine',
    EMPLOYEE_ABSENT_one: '{{count}} ménage assigné à un employé absent',
    EMPLOYEE_ABSENT_other: '{{count}} ménages assignés à un employé absent',
    SCHEDULE_CONFLICT_one: '{{count}} conflit d’horaire',
    SCHEDULE_CONFLICT_other: '{{count}} conflits d’horaire',
    QUOTES_TO_APPROVE_one: '{{count}} soumission à traiter',
    QUOTES_TO_APPROVE_other: '{{count}} soumissions à traiter',
    UNREAD_MESSAGES_one: '{{count}} message non lu',
    UNREAD_MESSAGES_other: '{{count}} messages non lus',
    FAILED_PAYMENTS_one: '{{count}} paiement échoué',
    FAILED_PAYMENTS_other: '{{count}} paiements échoués',
    REVIEW_REQUIRED_one: '{{count}} ménage à réviser',
    REVIEW_REQUIRED_other: '{{count}} ménages à réviser',
  },
  metrics: {
    jobsWeek: 'Ménages cette semaine',
    jobsToday_one: 'dont {{count}} aujourd’hui',
    jobsToday_other: 'dont {{count}} aujourd’hui',
    revenueWeek: 'Chiffre d’affaires (semaine)',
    employeeCostWeek: 'Coût employés (semaine)',
    marginWeek: 'Marge (semaine)',
    marginPct: '{{pct}} % du chiffre d’affaires',
    quotesToProcess: 'Soumissions à traiter',
    acceptanceRate: 'Taux d’acceptation',
    acceptanceHint: 'Soumissions des 90 derniers jours',
    recurringClients: 'Clients récurrents',
  },
  filters: {
    allStatuses: 'Tous les statuts',
    allSectors: 'Tous les secteurs',
    allEmployees: 'Tous les employés',
    allTeams: 'Toutes les équipes',
  },
  planning: {
    title: 'Planning',
    view: { day: 'Jour', week: 'Semaine', month: 'Mois', employee: 'Employé', team: 'Équipe' },
    jobsCount_one: '{{count}} ménage',
    jobsCount_other: '{{count}} ménages',
    more_one: '+{{count}} autre',
    more_other: '+{{count}} autres',
    free: 'Libre',
    emptyDay: 'Aucun ménage ce jour-là.',
    unassignedRow: 'Non assignés',
    noTeamRow: 'Sans équipe',
    moved: 'Ménage déplacé. Le client et l’équipe sont avisés.',
    dragHint: 'Glissez un ménage pour le déplacer.',
    dragHintEmployee: 'Glissez un ménage sur une autre ligne pour changer d’employé.',
  },
  dispatch: {
    button: 'Dispatch du jour',
    title: 'Dispatch du {{date}}',
    description: 'Meilleure proposition pour chaque ménage non assigné. Le moteur propose, vous décidez.',
    nothing: 'Tous les ménages de cette journée sont assignés.',
    confirm: 'Confirmer',
    confirmed: 'Assignation confirmée.',
    review: 'Voir les options',
    noProposal: 'Aucune proposition possible.',
  },
  newJob: {
    button: 'Nouveau ménage',
    title: 'Nouveau ménage',
    client: 'Client',
    clientSearch: 'Nom, courriel ou téléphone…',
    noClient: 'Aucun client trouvé.',
    changeClient: 'Changer',
    property: 'Propriété',
    noProperty: 'Ce client n’a aucune propriété. Ajoutez-en une depuis sa fiche.',
    service: 'Service',
    priceHint: 'Prix convenu avec le client.',
    invalid: 'Valeur invalide.',
    submit: 'Créer le ménage',
    created: 'Ménage créé.',
  },
  job: {
    title: 'Ménage #{{number}}',
    loading: 'Ménage',
    notFound: 'Ménage introuvable',
    open: 'Ouvrir la fiche',
    when: 'Date et heure',
    actual: 'Durée réelle : {{duration}}',
    address: 'Adresse',
    crewNeeds: 'Besoins',
    workers_one: '{{count}} personne',
    workers_other: '{{count}} personnes',
    priority: 'Priorité {{p}}',
    sector: 'Secteur {{name}}',
    property: 'Propriété',
    rooms: '{{bedrooms}} ch. · {{bathrooms}} sdb · {{floors}} étage(s)',
    pets: 'Animaux {{details}}',
    parking: 'Stationnement : {{info}}',
    cutoff: 'Délai client',
    cutoffLocked: 'Délai dépassé : toute modification de date est une dérogation.',
    cutoffOpen: 'Le client peut modifier jusqu’au {{deadline}}',
    permanentNotes: 'Notes permanentes de la propriété',
    completionNotes: 'Notes de fin de ménage',
    cancelReason: 'Raison de l’annulation',
    price: 'Prix',
  },
  crew: {
    title: 'Équipe assignée',
    none: 'Non assigné',
    noneLong_one: 'Aucun employé assigné ({{count}} requis).',
    noneLong_other: 'Aucun employé assigné ({{count}} requis).',
    missing_one: 'Il manque {{count}} personne.',
    missing_other: 'Il manque {{count}} personnes.',
    lead: 'Responsable',
    team: 'Équipe : {{name}}',
  },
  money: {
    title: 'Rentabilité',
    price: 'Prix client',
    crewCost: 'Coût de l’équipe',
    margin: 'Marge',
  },
  compensation: {
    adjust: 'Ajuster la rémunération',
    amount: 'Montant ($)',
    auto: 'Calcul automatique',
    saved: 'Rémunération mise à jour.',
  },
  assign: {
    title: 'Assigner le ménage',
    dispatchTitle: 'Dispatch',
    suggestions: 'Suggestions',
    manual: 'Choix manuel',
    engineHint: 'Classement du moteur (score le plus bas = meilleur). Le moteur propose, vous décidez.',
    suggestionsError: 'Impossible de calculer les suggestions.',
    noCandidates: 'Aucun employé disponible.',
    assign: 'Assigner',
    reassign: 'Réassigner',
    assignSelected: 'Assigner la sélection',
    done: 'Assignation enregistrée.',
    notAssignable: 'Ce ménage ne peut plus être assigné.',
    team: 'Équipe',
    teamHint: 'Choisir une équipe sélectionne ses membres actifs.',
    noTeam: 'Aucune équipe',
    employees: 'Employés',
    selectedCount: '{{selected}} sur {{required}} requis',
    onLeave: 'En congé',
    todayJobs_one: '{{count}} ménage aujourd’hui',
    todayJobs_other: '{{count}} ménages aujourd’hui',
    conflictTitle: 'Cette assignation crée un conflit',
    notEnough: '{{selected}} employé(s) choisi(s) pour {{required}} requis.',
    forceReason: 'Raison de la dérogation',
    force: 'Forcer l’assignation',
    forceNotAllowed: 'Seul un administrateur peut forcer cette assignation.',
    unassign: 'Désassigner',
    unassigned: 'Ménage désassigné.',
    unassignTitle: 'Retirer l’équipe de ce ménage ?',
    unassignDescription: 'Le ménage de {{client}} retournera dans la liste à assigner. Les employés seront avisés.',
  },
  candidate: {
    eligible: 'Admissible',
    ineligible: 'Conflit',
    kind: { EMPLOYEE: 'Employé', TEAM: 'Équipe', PAIR: 'Duo' },
    score: 'Score {{score}}',
    none: 'Aucune combinaison possible',
    far: 'Distance élevée',
    showBreakdown: 'Voir le détail du score',
    hideBreakdown: 'Masquer le détail',
  },
  score: {
    distance: 'Trajet',
    distanceValue: '{{km}} km · {{min}} min',
    distanceCost: 'Coût du trajet',
    continuityBonus: 'Bonus continuité',
    sectorBonus: 'Bonus secteur',
    capacityPenalty: 'Charge du jour',
    overtimePenalty: 'Heures supp.',
    schedulePenalty: 'Horaire serré',
  },
  conflict: {
    INACTIVE: 'Employé inactif ou en congé',
    TIME_OFF: 'Absence prévue ce jour-là',
    OUTSIDE_AVAILABILITY: 'Hors de ses disponibilités',
    OVERLAP: 'Chevauche un autre ménage',
    MAX_JOBS: 'Nombre maximal de ménages atteint',
    MAX_HOURS: 'Nombre maximal d’heures dépassé',
    MISSING_SKILL: 'Compétence requise manquante',
    SECTOR_NOT_ALLOWED: 'Secteur non desservi par cet employé',
    TEAM_CAPACITY: 'Capacité de l’équipe atteinte',
    NOT_ENOUGH_WORKERS: 'Pas assez d’employés disponibles',
  },
  status: {
    title: 'Changer le statut',
    quick: 'Statut',
    changed: 'Statut mis à jour.',
    reasonTitle: 'Passer à « {{status}} »',
    overrideTitle: 'Terminer malgré la liste incomplète',
    overrideChecklist: 'Des tâches obligatoires ne sont pas cochées. Indiquez pourquoi le ménage est tout de même terminé.',
    overrideConfirm: 'Terminer',
    action: {
      DRAFT: 'Brouillon',
      UNASSIGNED: 'Remettre à assigner',
      ASSIGNED: 'Marquer assigné',
      CONFIRMED: 'Confirmer',
      EN_ROUTE: 'En route',
      ARRIVED: 'Arrivé',
      IN_PROGRESS: 'Commencer',
      COMPLETED: 'Terminer',
      REVIEW_REQUIRED: 'Demander une révision',
      CANCELLED: 'Annuler',
      NO_SHOW: 'Client absent',
    },
  },
  override: {
    cutoffTitle: 'Délai client dépassé',
    cutoffDescription: 'Ce ménage est dans la période de verrouillage. Indiquez la raison de la modification (elle sera journalisée).',
    confirm: 'Modifier quand même',
  },
  reason: {
    label: 'Raison',
    hint: 'Au moins 2 caractères.',
  },
  edit: {
    title: 'Modifier le ménage #{{number}}',
    saved: 'Ménage mis à jour.',
    durationMinutes: 'Durée (minutes)',
    price: 'Prix client ($)',
    workers: 'Nombre de personnes',
    priority: 'Priorité',
    notes: 'Notes internes',
    notesHint: 'Visibles par le personnel seulement.',
    specialInstructions: 'Instructions particulières',
    instructionsHint: 'Visibles par l’équipe et le client.',
    lockedHint: 'Délai client dépassé : un changement de date ou d’heure demandera une raison.',
    lockedNoOverride: 'Délai client dépassé : seul un administrateur peut changer la date ou l’heure.',
  },
  cancel: {
    button: 'Annuler le ménage',
    title: 'Annuler le ménage #{{number}} ?',
    description: 'Le client et l’équipe seront avisés.',
    lockedDescription: 'Le délai client est dépassé : cette annulation est une dérogation journalisée.',
    reason: 'Raison de l’annulation',
    confirm: 'Annuler le ménage',
    keep: 'Garder',
    done: 'Ménage annulé.',
    notifyHint: 'La raison est conservée dans l’historique.',
  },
  checklist: {
    title: 'Liste de tâches',
    progress: '{{done}} / {{total}}',
    empty: 'Aucune tâche pour ce ménage.',
    optional: 'facultatif',
    addedBadge: 'Ajoutée',
    section: 'Section',
    newTask: 'Nouvelle tâche',
    added: 'Tâche ajoutée.',
    removed: 'Tâche retirée.',
    remove: 'Retirer « {{label}} »',
    removeTitle: 'Retirer cette tâche ?',
  },
  history: {
    title: 'Historique',
    empty: 'Aucun changement de statut.',
    created: 'Créé : {{status}}',
    override: 'Dérogation',
    system: 'Système',
  },
  map: {
    title: 'Carte',
    description: 'Propriétés, ménages du jour, domiciles des employés et secteurs.',
    filter: 'Filtre',
    mode: { all: 'Tous', unassigned: 'Non assignés', team: 'Équipe', employee: 'Employé', sector: 'Secteur', status: 'Statut' },
    chooseValue: 'Choisir…',
    layer: { houses: 'Maisons', homes: 'Domiciles', sectors: 'Secteurs' },
    homeOf: 'Domicile de {{name}}',
    jobsTab_one: '{{count}} ménage',
    jobsTab_other: '{{count}} ménages',
    noJobs: 'Aucun ménage pour ce filtre.',
    noCoordinates: 'adresse non localisée',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    resetView: 'Recentrer',
  },
  route: {
    title: 'Route du jour',
    employee: 'Employé',
    chooseEmployee: 'Choisir un employé…',
    noJobs: 'aucun ménage',
    hint: 'Choisissez un employé pour voir son trajet de la journée.',
    show: 'Voir la route',
    optimize: 'Optimiser',
    optimized: 'Optimisée',
    optimizeHint: 'L’optimisation peut décaler les arrivées de 45 minutes au plus; les heures promises ne sont pas modifiées.',
    empty: 'Aucun arrêt ce jour-là.',
    feasible: 'Réalisable',
    notFeasible: 'Retards prévus',
    totals: '{{km}} km · {{min}} min de route',
    leg: '{{min}} min · {{km}} km · arrivée {{arrival}}',
    wait: 'attente {{min}} min',
    late: 'Retard de {{min}} min',
    noCoordinates_one: '{{count}} arrêt sans coordonnées.',
    noCoordinates_other: '{{count}} arrêts sans coordonnées.',
  },
};
